import GeneralHeader from './GeneralHeader'

function BehaviourNotesHeader() {
    return (
        <div>
            <GeneralHeader />
        </div>
    )
}

export default BehaviourNotesHeader